import React from 'react'
import { Link } from 'react-router-dom'
import BestSeller from './BestSeller'
import Procedure from './ProductProcedure'
import { useParams } from 'react-router-dom';
import { data } from '../../Index/tab/Data';

const ProdHome = () => {
    const {id} = useParams();
    const item = data.find(d => d.title === id)
    return (
        <div className='flex flex-col mt-6 lg:gap-14 gap-10 z-[400]'>
            <div className='absolute lg:block hidden w-[400px] h-[400px] left-[-100px] top-[-200px] bg-blue-400 bg-opacity-30 rounded-full blur-2xl'></div>
            <div className='flex my-7 p-3 border border-white rounded-lg '>hello</div>
            <div className='flex lg:flex-row flex-col items-center w-full lg:gap-9'>
                <div className='flex flex-col gap-3'>
                    {/* <img width={500} src="/Blockfarm/feature1.svg" alt="" /> */}
                    <img width={500} src={item.img} alt="" />
                    <div className='flex w-full justify-between'>
                        <img src={item.subImg1} alt="" />
                        <img src={item.subImg2} alt="" />
                        <img src={item.subImg3} alt="" />
                        <img src={item.subImg4} alt="" />
                    </div>

                </div>
                <div className='lg:w-[60%] w-full flex flex-col gap-9 lg:mt-0 mt-4'>
                    <p className='lg:text-[45px] text-[25px] font-bold text-white'>{item.title}</p>
                    <p className='flex text-white font-semibold lg:text-[18px]'>{item.description}</p>
                    <div className='flex items-center flex-row w-full'>
                        <p className='lg:text-[22px] text-[15px] font-semibold text-white'>Bitmain Detail</p>
                        <img src="/Blockfarm/Line 3.svg" className='lg:block hidden' width={600} alt="" />
                    </div>
                    <div className='grid lg:grid-cols-2 gap-4'>
                        <div className='flex flex-row items-center gap-3'>
                            <img src="/Blockfarm/round.svg" alt="" />
                            <p className='text-white font-bold'>Megaheartz: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                                {item.Megaheartz}
                            </span></p>
                        </div>
                        <div className='flex flex-row items-center gap-3'>
                            <img src="/Blockfarm/round.svg" alt="" />
                            <p className='text-white font-bold'>Algorithm: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                                {item.Algorithm}
                            </span></p>
                        </div>
                        <div className='flex flex-row items-center gap-3'>
                            <img src="/Blockfarm/round.svg" alt="" />
                            <p className='text-white font-bold'>Power: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                                {item.power}
                            </span></p>
                        </div>
                        <div className='flex flex-row items-center gap-3'>
                            <img src="/Blockfarm/round.svg" alt="" />
                            <p className='text-white font-bold'>Mineable Coins: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                                {item.mineable}
                            </span></p>
                        </div>
                    </div>
                    <div className='flex flex-col gap-4'>
                        <div className='flex items-center flex-row w-full'>
                            <p className='lg:text-[22px] text-[15px] font-semibold text-white'>Others Detail</p>
                            <img className='lg:block hidden' src="/Blockfarm/Line 3.svg" width={600} alt="" />
                        </div>
                        <div className='grid lg:grid-cols-2 gap-4'>
                            {/* <div className='flex flex-row items-center gap-3'>
                                <img src="/Blockfarm/round.svg" alt="" />
                                <p className='text-white font-bold'>Location: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                                    USA
                                </span></p>
                            </div> */}
                            <div className='flex flex-row items-center gap-3'>
                                <img src="/Blockfarm/round.svg" alt="" />
                                <p className='text-white font-bold'>Release Date: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                                    {item.date}
                                </span></p>
                            </div>
                            <div className='flex flex-row items-center gap-3'>
                                <img src="/Blockfarm/round.svg" alt="" />
                                <p className='text-white font-bold'>Delivery Time: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                                    {item.delivery}
                                </span></p>
                            </div>
                            <div className='flex flex-row items-center gap-3'>
                                <img src="/Blockfarm/round.svg" alt="" />
                                <p className='text-white font-bold'>Price: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                                    {item.amount}
                                </span></p>
                            </div>
                        </div>
                        <div className='flex justify-between gap-4 w-full z-[500]'>
                            <div className='flex w-full'>
                                <Link className='w-full' to={"#"}>
                                    <button className='started lg:w-full w-full py-3 px-[20px] rounded-xl text-white lg:text-[18px] text-[12px] flex items-center justify-center font-bold'>BUY NOW</button>
                                </Link>
                            </div>
                            <div className='flex w-full'>
                                <Link className='w-full' to={""}>
                                    <button className='border-[1px] border-blue-400 px-[20px] text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700 w-full lg:w-full py-3 rounded-xl text-[12px] lg:text-[18px] flex items-center font-bold justify-center'>SEE MORE</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Procedure/>
            <BestSeller/>

        </div>
    )
}

export default ProdHome